// Import modular Firebase SDK
import { initializeApp, getApps, getApp } from "firebase/app";

// Konfigurasi dari Firebase Console
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // The value of `storageBucket` depends on when you provisioned your default bucket (learn more)
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Pastikan Firebase tidak diinisialisasi 2x (hot reload dev mode)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export default app;
